import React from 'react';
import { COLORS } from '../../styles/tokens';

const STATUS = {
  issued:   { text: 'Utstedt',   bg: COLORS.blueBg,       color: COLORS.blueText },
  overdue:  { text: 'Forfalt',   bg: COLORS.dangerBg,     color: COLORS.dangerText },
  paid:     { text: 'Betalt',    bg: COLORS.successBg,    color: COLORS.successText },
  credited: { text: 'Kreditert', bg: COLORS.surfaceHover, color: COLORS.textMid },
};
const CREDIT_NOTE = { text: 'Kreditnota', bg: COLORS.purpleBg, color: COLORS.purpleText };

export default function InvoiceStatusChip({ invoice }) {
  const info = invoice.kind === 'credit-note'
    ? CREDIT_NOTE
    : STATUS[invoice.status] ?? { text: invoice.status, bg: COLORS.surfaceHover, color: COLORS.textLight };
  return (
    <span style={{
      display: 'inline-block', borderRadius: 20, padding: '3px 10px', fontSize: 11.5,
      fontWeight: 700, whiteSpace: 'nowrap', background: info.bg, color: info.color,
    }}>{info.text}</span>
  );
}
